import React, { useEffect } from "react";
import BtnGuardar from "../buttons/BtnGuardar";
import BtnCancelar from "../buttons/BtnCancelar";

export default function DrawerFilter({
  title = "Filtros",
  onClose,
  onApply,
  isLoading = false,
  children,
  applyLabel = "Aplicar",
}) {
  
  // 1. Cerrar con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && onClose && !isLoading) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose, isLoading]);

  // 2. Manejar Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onApply && !isLoading) {
      onApply();
    }
  };

  return (
    <div className="drawer-backdrop fixed inset-0 z-50 flex justify-end">
      
      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%) }
          to { transform: translateX(0) }
        }
        .animate-slide-in {
          animation: slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .drawer-backdrop {
          background-color: rgba(0, 0, 0, 0.4);
        }
      `}</style>

      {/* PANEL PRINCIPAL */}
      <div
        className="drawer-panel w-full sm:max-w-sm flex flex-col h-[100dvh] bg-white shadow-2xl overflow-hidden animate-slide-in"
        style={{ padding: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        
        {/* A. HEADER */}
        <div className="drawer-header shrink-0 p-5 sm:p-6 border-b border-gray-100 flex justify-between items-center bg-white">
          <h2 className="text-title text-lg sm:text-xl font-bold text-gray-800">{title}</h2>
          
          {/* --- NUEVO BOTÓN DE CERRAR (Ghost Circle) --- */}
          <button
            type="button"
            onClick={!isLoading ? onClose : undefined}
            className={`p-2 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-green-500/50 ${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={isLoading}
            aria-label="Cerrar"
          >
            {/* SVG limpio en lugar de &times; */}
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* B. BODY SCROLLABLE */}
        <div className="flex-1 overflow-y-auto p-5 sm:p-6 bg-white">
          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            
            {/* Contenedor de Inputs (Children) */}
            <div className="flex flex-col gap-5">
              {children}
            </div>

            {/* C. BOTONES DE ACCIÓN */}
            <div className="mt-4 flex gap-3 justify-start pb-2">
              <BtnGuardar
                label={isLoading ? "Procesando..." : applyLabel}
                onClick={handleSubmit}
                isValid={!isLoading}
                disabled={isLoading}
                className="rounded-full shadow-md transition-all"
              />
              <BtnCancelar 
                onClick={onClose} 
                disabled={isLoading}
                className="rounded-full" 
              />
            </div>
            
          </form>
        </div>
      </div>
    </div>
  );
}